module.exports = __webpack_public_path__ + "media/images/ipad-42677927cf7b7b2e1c5091c4ba4053a9.png";